import adsManager from './ads-manager'
import properties from './properties'
import account from './account'
// import info from './info'

export default [
  ...adsManager,
  ...properties,
  ...account,
  // ...info,
]
